/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlDefinition } from "@anvilor/ngx-rui";
import { LegacyRuiControl } from "@anvilor/ngx-rui";
import { RuiStore } from "@anvilor/ngx-rui";
import { Observable } from "rxjs";
import { distinctUntilChangedJson } from "@anvilor/ngx-core-utils";

export const CONTROL_SUBMIT_BUTTON = "anvilor_forms:submit_button";

export interface CloseDialogSideEffect {
  action: "close_dialog";
  dialog_id: string;
}

export type SubmitButtonSuccessSideEffect = CloseDialogSideEffect;

export interface SubmitButtonControlDefinition extends ControlDefinition {
  control: typeof CONTROL_SUBMIT_BUTTON;
  button_label?: string;
  additional_disable?: boolean;
  payload?: any;

  // Added mainly as a workaround (See #213, dicorp/asl/tech/libs/ngx-rui#136)
  use_rui_validation?: boolean;

  side_effects?: SubmitButtonSuccessSideEffect[];
}

// eslint-disable-next-line max-len
export class SubmitButtonControl extends LegacyRuiControl<SubmitButtonControlDefinition> {
  buttonLabel$: Observable<string>;
  useRuiValidation$: Observable<boolean>;
  additionalDisable$: Observable<boolean>;
  payload$: Observable<any>;
  postSubmitSideEffects$: Observable<SubmitButtonSuccessSideEffect[]>;

  constructor(store: RuiStore, id: string) {
    super(store, id);

    this.useRuiValidation$ = this.evaluatedSelect((d) => d.use_rui_validation ?? true);
    this.buttonLabel$ = this.selectors
      .evalDefnSelect((d) => d.button_label ?? "Submit")
      .pipe(distinctUntilChangedJson());

    this.additionalDisable$ = this.selectors.evalDefnSelect(
      (d) => d.additional_disable ?? false
    );

    this.postSubmitSideEffects$ = this.evaluatedSelect((d) => d.side_effects);

    this.payload$ = this.selectors.evalDefnSelect((d) => d.payload);
  }
}
